/**
 * Cookie utility functions
 * Client-side のみで使用（SSR では使用不可）
 */

export const ANONYMOUS_SCORER_ID_COOKIE = "anonymous_scorer_id";

/**
 * 指定された名前の cookie 値を取得
 */
export const getCookieValue = (name: string): string | undefined => {
  if (typeof window === "undefined") {
    return undefined;
  }

  const cookies = document.cookie
    .split(";")
    .map((cookie) => cookie.trim())
    .filter((cookie) => cookie.length > 0);

  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split("=");
    if (decodeURIComponent(cookieName) === name) {
      return decodeURIComponent(cookieValue);
    }
  }

  return undefined;
};

/**
 * anonymous_scorer_id cookie を取得
 */
export const getAnonymousScorerId = (): string | undefined => {
  return getCookieValue(ANONYMOUS_SCORER_ID_COOKIE);
};
